var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundBubbles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1336,
    height: 453,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16,
    clipPath: "url(#background-bubbles_svg__clip0_2129_11960)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1629 440.402l-28.8 3.644c-28.8 3.645-88 10.933-145.6 18.222-57.6 7.289-116.8 14.577-174.4 7.289-59.2-7.289-116.8-29.155-174.4-32.799-59.2-3.645-116.8 10.933-174.4 3.644-59.2-7.289-116.8-36.443-174.4-43.732-59.2-7.289-116.8 7.289-176 18.222-57.6 10.933-115.2 18.221-174.4 7.288-57.6-10.933-115.2-40.087-174.4-54.665-57.6-14.577-115.2-14.577-174.4 3.645C.2 389.381-59 425.825-116.6 447.691c-57.6 21.866-116.8 29.154-145.6 32.799l-28.8 3.644V506H1629v-65.598z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-291 435.037l28.8 4.109c28.8 4.109 88 12.327 145.6 20.545C-59 467.91.2 476.128 57.8 467.91c59.2-8.219 116.8-32.873 174.4-36.982 59.2-4.109 116.8 12.327 174.4 4.109 59.2-8.218 116.8-41.09 174.4-49.308 59.2-8.218 116.8 8.218 176 20.545 57.6 12.327 115.2 20.545 174.4 8.218 57.6-12.327 115.2-45.199 174.4-61.636 57.6-16.436 115.2-16.436 174.4 4.109 57.6 20.546 116.8 61.636 174.4 86.29 57.6 24.655 116.8 32.873 145.6 36.982l28.8 4.109V509H-291v-73.963z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388,
    cy: 238,
    r: 22,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 227,
    r: 28,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 283,
    r: 28,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311,
    cy: 145,
    r: 16,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163,
    cy: 311,
    r: 16,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 78.5,
    r: 7.5,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 241.5,
    cy: 121.5,
    r: 7.5,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.5,
    cy: 50.5,
    r: 7.5,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909,
    cy: 311,
    r: 40,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 743,
    cy: 258,
    r: 40,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1120,
    cy: 270,
    r: 28,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1278,
    cy: 267,
    r: 28,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465,
    cy: 357,
    r: 28,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1011,
    cy: 188,
    r: 16,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 872,
    cy: 189,
    r: 16,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1339,
    cy: 188,
    r: 16,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 614,
    cy: 105,
    r: 16,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645,
    cy: 341,
    r: 16,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1070.5,
    cy: 121.5,
    r: 7.5,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 909.5,
    cy: 112.5,
    r: 7.5,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 621.5,
    cy: 196.5,
    r: 7.5,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.5,
    cy: 149.5,
    r: 7.5,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 768.5,
    cy: 93.5,
    r: 7.5,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 537.5,
    cy: 257.5,
    r: 7.5,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1269.5,
    cy: 164.5,
    r: 7.5,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 544.5,
    cy: 81.5,
    r: 7.5,
    fill: "#F1F1F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "background-bubbles_svg__clip0_2129_11960"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-291)",
    d: "M0 0h1920v453H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/background-bubbles.6361e4b8.svg";
export { SvgBackgroundBubbles as ReactComponent };